import { twMerge } from "tailwind-merge";
import Skeleton from "../Skeleton";

interface ResumeItemProps {
  label: string;
  value: string | JSX.Element;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  containerClassName?: string;
  valueDataTestid?: string;
  isLoading?: boolean;
  labelIsLoading?: boolean
  skeletonValueWidth?: number;
}

const ResumeItem = ({
  label,
  value,
  className,
  containerClassName,
  labelClassName,
  valueClassName,
  valueDataTestid,
  isLoading,
  labelIsLoading = false,
  skeletonValueWidth,
}: ResumeItemProps) => {
  return (
    <div className={twMerge('flex flex-col', className, containerClassName)}>
      {labelIsLoading ? <Skeleton className="h-3 mb-2" /> : (
        <p className={twMerge('font-light italic text-[14px] text-white-800', className, labelClassName)}>
          {label}
        </p>
      )}

      {isLoading && (
        <div className="h-[27px] items-center">
          <Skeleton width={skeletonValueWidth || Math.floor(Math.random() * (150 - 60) + 60)} height={22} />
        </div>
      )}

      {!isLoading && (
        <p className={twMerge('text-[18px] text-white-800', className, valueClassName)} data-testid={valueDataTestid}>
          {value || '--'}
        </p>
      )}
    </div>
  );
}

export default ResumeItem;
